// extracted by mini-css-extract-plugin
module.exports = {"root":"HealthCreateEdit_root__2BSm0"};